var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDangerSquare({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5013 1.41699C5.16219 1.41699 3.49263 1.41699 2.4553 2.45432C1.41797 3.49165 1.41797 5.16121 1.41797 8.50033C1.41797 11.8394 1.41797 13.509 2.4553 14.5463C3.49263 15.5837 5.16219 15.5837 8.5013 15.5837C11.8404 15.5837 13.51 15.5837 14.5473 14.5463C15.5846 13.509 15.5846 11.8394 15.5846 8.50033C15.5846 5.16121 15.5846 3.49165 14.5473 2.45432C13.51 1.41699 11.8404 1.41699 8.5013 1.41699ZM8.5013 4.42741C8.7947 4.42741 9.03255 4.66526 9.03255 4.95866V9.20866C9.03255 9.50206 8.7947 9.73991 8.5013 9.73991C8.2079 9.73991 7.97005 9.50206 7.97005 9.20866V4.95866C7.97005 4.66526 8.2079 4.42741 8.5013 4.42741ZM8.5013 12.042C8.8925 12.042 9.20964 11.7249 9.20964 11.3337C9.20964 10.9425 8.8925 10.6253 8.5013 10.6253C8.1101 10.6253 7.79297 10.9425 7.79297 11.3337C7.79297 11.7249 8.1101 12.042 8.5013 12.042Z",
    fill: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDangerSquare);
export default __webpack_public_path__ + "static/media/dangerSquare.e6a36895bda850ff2aef75740b3b1372.svg";
export { ForwardRef as ReactComponent };